export const productUnitTypes = () => ([
    {id: 'kg', value: 'Kg'},
    {id: 'liter', value: 'Liter'},
    {id: 'ml', value: 'ML'},
    {id: 'set', value: 'Set'},
    {id: 'ounce', value: 'Ounce'},
    {id: 'gram', value: 'Gram'},
    {id: 'lb', value: 'Pound'},
    {id: 'piece', value: 'Piece'},
]);